module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"close":"Schließen"},"en":{"close":"Close"},"it":{"close":"Chiudere"},"lt":{"close":"Uždaryti"},"pl":{"close":"Zamknij"},"es":{"close":"Cerca"}}')
  delete Component.options._Ctor
}
